import React, { useEffect, useState, useCallback } from 'react';
import { Box, Button, HStack, Icon } from '@chakra-ui/react';
import { CheckIcon, CloseIcon } from '@chakra-ui/icons';
import { SuccessToastProps } from '../types';
import { useSelector } from 'react-redux';
import { ApplicationState } from '@/store';
import { usedByAgent, usedByPartner, usedByUniStaff } from '../utils';
import { useTranslation } from "react-i18next";

const LOADING_DURATION = 10000; // 10 seconds

export const SuccessToast: React.FC<SuccessToastProps> = ({ onClose, preferredName, uni, userId }) => {
    const { t } = useTranslation('forms.registration');
  const [isLoading, setIsLoading] = useState(true);
  const auth = useSelector((state: ApplicationState) => state.auth);
  const isAgent = usedByAgent(auth.role);
  const isPartner = usedByPartner(auth.role);
  const isUniStaff = usedByUniStaff(auth.role);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, LOADING_DURATION);

    return () => clearTimeout(timer);
  }, []);

  const handleOpen = useCallback(() => {
    if (!isLoading) {
      onClose();
      if (isAgent || isPartner) window.location.href = `/apply/application/${uni}/${userId}`;
      if (isUniStaff) window.location.href = `/apply/staff/application/${uni}/${userId}`;
    }
  }, [isLoading, onClose, uni, userId, isAgent, isPartner, isUniStaff]);

  return (
    <Box bg="green.100" p={3} rounded="md" color="gray.800">
      <HStack justify="space-between" align="center">
        <HStack spacing={2}>
          <Icon as={CheckIcon} color="green.500" />
          <Box>{preferredName} {t('forms.registration:createdAsALead')}</Box>
        </HStack>
        <HStack spacing={2}>
          <Button
            onClick={handleOpen}
            size="sm"
            colorScheme="blue"
            variant="solid"
            isLoading={isLoading}
            loadingText={t('forms.registration:preparing')}
          >
            {t('forms.registration:open')}
                                </Button>
          <Button size="sm" variant="ghost" onClick={onClose} p={0} aria-label={t('forms.registration:closeNotification')}>
            <CloseIcon boxSize={3} />
          </Button>
        </HStack>
      </HStack>
    </Box>
  );
};
